import { enableProdMode } from '@angular/core';
import { platformBrowserDynamic } from '@angular/platform-browser-dynamic';

import { AppModule } from './app/app.module';
import { environment } from './environments/environment';

function loadGoogleMapsApi(): Promise<void> {
  const win = window as any;
  if (win.google?.maps) {
    return Promise.resolve();
  }

  const existing = document.querySelector(
    'script[data-google-maps-api="true"]'
  ) as HTMLScriptElement | null;
  if (existing) {
    return new Promise((resolve, reject) => {
      existing.addEventListener('load', () => resolve());
      existing.addEventListener('error', () => reject());
    });
  }

  return new Promise((resolve, reject) => {
    const script = document.createElement('script');
    script.setAttribute('data-google-maps-api', 'true');
    script.async = true;
    script.defer = true;
    script.src = `https://maps.googleapis.com/maps/api/js?key=${environment.google_maps_api_key}`;
    script.onload = () => resolve();
    script.onerror = () => reject(new Error('Failed to load Google Maps API'));
    document.head.appendChild(script);
  });
}

if (environment.production) {
  enableProdMode();
}

loadGoogleMapsApi()
  .catch(err => console.error(err))
  .finally(() => {
    platformBrowserDynamic()
      .bootstrapModule(AppModule)
      .catch(err => console.error(err));
  });
